import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { FiltersCard } from "components/Common/FiltersCard"
import axios from "axios"
import { API_URL, sitename } from "constants/constants"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "../../../components/Common/Toaster";
import "../../../assets/table.css";
import TableLoader from "../../../components/Common/TableLoader";
import moment from "moment";

const CashoutTickets
    = props => {
        const [item, setItem] = useState("All")
        const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
        const [liveData, setLive] = useState("pre-game")
        const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
        const [total, setTotal] = useState(0)
        const [nextPageUrl, setNextPageUrl] = useState("")
        const [prevPageUrl, setPrevPageUrl] = useState("")
        const [callUrl, setCallUrl] = useState("")
        const [loadingMessage, setLoadingMessage] = useState("1");
        const [currentPage, setCurrentPage] = useState(1);
        const [lastPage, setLastPage] = useState(0);
        const [itemsPerPage] = useState(10);
        const [filtersData, setFiltersData] = useState({
            item: "",
            fromDate: "",
            toDate: "",
        })
        const [data, setData] = useState([])
        const [modelData, setModalData] = useState([])
        const options = [
            { label: "Lost", value: "Lost" },
            { label: "Won", value: "Won" },
            { label: "All", value: "All" },
            { label: "Pending", value: "Pending" },
            { label: "Void", value: "Void" },
        ]

        useEffect(() => {
            call()
        }, [])

        const call = () => {
            setLoadingMessage("1");
            axios({
                method: "get",
                url: `${API_URL}/client/sports-cashout-reports?&to=${toDate}&from=${fromDate}&type=${liveData}`,
            })
                .then(function (response) {
                    const totalCount = response?.data?.count;

                    const lastPageCalc = Math.ceil(totalCount / itemsPerPage);
                    setData(response?.data?.data)
                    setLastPage(lastPageCalc);

                    setTotal(response?.data?.data?.count)

                    // setNextPageUrl(response?.data?.data?.next_page_url)
                    // setCurrentPage(response?.data?.data?.current_page)
                    // setLastPage(response?.data?.data?.last_page)

                    setLoadingMessage("0");
                })
                .catch(function (response) { })
        }

        
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

       
        $(document).off("click").on("click", "ul.pagination li a", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let page = $(this).text();
            if (page === ">") {
                if (currentPage < lastPage) page = currentPage + 1;
            } else if (page === ">>") {
                page = lastPage;
            } else if (page === "<") {
                if (currentPage > 1) page = currentPage - 1;
            } else {
                page = parseInt(page);
            }

            if (!isNaN(page)) {
                setCurrentPage(page);
                updatePaginationUI(page);
            }
        });

        const updatePaginationUI = (page) => {
            $("ul.pagination li").removeClass("active");
            $(`ul.pagination li[title="${page}"]`).addClass("active");

            if (page > 1) {
                $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').removeClass("disabled");
                $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').removeClass("disabled");
            } else {
                $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').addClass("disabled");
                $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').addClass("disabled");
            }
        };


        const callById = id => {
            axios({
                method: "get",
                url: `${API_URL}/client/reports/sport-tickets?id=${id}&match_type=${liveData}&unsetPagination=${true}`,
            })
                .then(function (response) {
                    setModalData(response?.data?.data[0])
                })
                .catch(function (response) { })
        }

        const cancelTicketCall = (id) => {
            axios({
                method: "get",
                url: `${API_URL}/client/reports/cancel-tickets/${id}`,
            })
                .then(function (response) {
                    showMessage("success", response.data.message)
                    call();
                })
                .catch(function (response) {
                    showErrorMessages(response)
                })
        }

        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>{sitename}</title>
                    </MetaTags>
                    <Container fluid>
                        {/* Render Breadcrumb */}
                        <Breadcrumbs title="Admin" breadcrumbItem="Cashout Tickets" />
                    </Container>
                    <FiltersCard
                        item={item}
                        setItem={setItem}
                        options={options}
                        fromDate={fromDate}
                        toDate={toDate}
                        setToDate={setToDate}
                        setFromDate={setFromDate}
                        showToDate={true}
                        hideShowType={true}
                        setFiltersData={setFiltersData}
                        call={() => {
                            call()
                        }}

                    />
                    <Table data={data}
                        modelData={modelData}
                        liveData={liveData}
                        setLive={setLive}
                        callById={(id) => {
                            callById(id)
                        }}
                        call={() => {
                            call()
                        }}
                        cancelTicketCall={(id) => {
                            cancelTicketCall(id)
                        }}
                        item={item}
                        toDate={toDate}
                        fromDate={fromDate}
                        loadingMessage={loadingMessage}
                        setLoadingMessage={setLoadingMessage}
                        setTotal={setTotal}
                        total={total}
                        currentPage={currentPage}
                        setCallUrl={setCallUrl}
                        setPrevPageUrl={setPrevPageUrl}
                        prevPageUrl={prevPageUrl}
                        nextPageUrl={nextPageUrl}
                        setNextPageUrl={setNextPageUrl}
                    />

                </div>
            </React.Fragment>
        )
    }

export default withRouter(CashoutTickets)
